<script setup>
import { useQuestionsStore, useAnswersStore } from '@stores';

const questionsStore = useQuestionsStore();
const answersStore = useAnswersStore();

const props = defineProps(['element']);

const isMultipleChoice = questionsStore.question.type === 1 || questionsStore.question.type === 2;

const correctAnswerHandler = async (selectedAnswer) => {
    if (!questionsStore.question.isMultiple && selectedAnswer.isCorrect) {
        questionsStore.question.answers.forEach((ans) => {
            if (ans.answer_id !== selectedAnswer.answer_id) {
                ans.isCorrect = false;
            }
        });
    }
    await answersStore.updateAnswer(selectedAnswer, { isCorrect: selectedAnswer.isCorrect });
};
</script>

<template>
    <div class="answer-variant-buttons">
        <Checkbox @change="correctAnswerHandler(element)" v-model="element.isCorrect" :binary="true" class="mr-2" v-if="isMultipleChoice" />

        <Button @click.stop="answersStore.deleteAnswer(element.answer_id)" icon="pi pi-times" variant="text" severity="danger" />
        <Button icon="pi pi-arrows-alt" variant="text" class="drag-handler" />
    </div>
</template>

<style scoped>
.answer-variant-buttons {
    @apply flex items-center;
}
</style>
